import { render, staticRenderFns } from "./free.vue?vue&type=template&id=656c389c&scoped=true"
import script from "./free.vue?vue&type=script&lang=js"
export * from "./free.vue?vue&type=script&lang=js"
import style0 from "./free.vue?vue&type=style&index=0&id=656c389c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c389c",
  null
  
)

export default component.exports